import { VSBuffer } from '../../../../base/common/buffer.js';
var UIKind;
( (function(UIKind) {
    UIKind[UIKind["Desktop"] = 1] = "Desktop";
    UIKind[UIKind["Web"] = 2] = "Web";
})(UIKind || (UIKind = {})));
function createMessageOfType(type) {
    const result = VSBuffer.alloc(1);
    switch (type) {
        case 0 :
            result.writeUInt8(1, 0);
            break;
        case 1 :
            result.writeUInt8(2, 0);
            break;
        case 2 :
            result.writeUInt8(3, 0);
            break;
    }
    return result;
}
function isMessageOfType(message, type) {
    if (message.byteLength !== 1) {
        return false;
    }
    switch (message.readUInt8(0)) {
        case 1: return type === 0 ;
        case 2: return type === 1 ;
        case 3: return type === 2 ;
        default: return false;
    }
}
export { UIKind, createMessageOfType, isMessageOfType };
